export default __webpack_public_path__ + "static/media/growth.fcefeb55.png";